module.exports = __webpack_public_path__ + "img/vi.2cca2f6.svg";